import React, { Component } from "react";
import styled from "styled-components";

import defaultLogo from "../../static/images/logo/formant-default-logo.svg";

export interface ILogoProps {
    className?: string;
    src?: string;
}

const NonDraggableImg = styled.img`
    pointer-events: none;
    user-select: none;
`;

export class Logo extends Component<ILogoProps> {
    public render() {
        const { className, src } = this.props;
        const logoSrc = src !== undefined ? src : defaultLogo;

        return <NonDraggableImg className={className} src={logoSrc} />;
    }
}
